module.exports = __webpack_public_path__ + "img/read_1.03c36eda.svg";